import "./DesignAndPlanning.html";

import "./ProjectionMap/ProjectionMapComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import DesignAndPlanningComponentController from "./DesignAndPlanningComponentController";

export default class DesignAndPlanningComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            siteId: "<",
        };
        this.controller = DesignAndPlanningComponentController;
        this.templateUrl = "/App/Components/Site/DesignAndPlanning/DesignAndPlanning.html";
    }
}

module("mmManagePortal").component("mmDesignAndPlanning", new DesignAndPlanningComponent());
